module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Delete Trade","prependMessage":"Are you sure to delete the trade related with","btnDelete":"Yes, delete it"},"es":{"title":"Eliminar Trade","prependMessage":"¿Estas seguro de eliminar el trade relacionado con","btnDelete":"Sí, eliminar ahora"}}')
  delete Component.options._Ctor
}
